import {
  useAnalyticsAbResultsGetApi,
  useAnalyticsAlgorithmPerformanceGetApi
} from '@/common/api/modules/analytics'
import { algorithmName } from '@/common/app/modules/algorithm'

import Content from '@/components/view/layouts/page/Content'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'
import PageTitle from '@/components/view/molecules/title/PageTitle'

import AnalyticsResultCard from '@/components/container/modules/admin/analytics/AnalyticsResultCard'

// A/Bテストのグループ名を表示用に変換する
const abGroupLabel = (group: string) => (group === 'default' ? 'デフォルト' : group)

const AnalyticsPage = () => {
  const { data: abResults } = useAnalyticsAbResultsGetApi()
  let { data: algorithmPerformance } = useAnalyticsAlgorithmPerformanceGetApi()

  return (
    <Main type={MainLayoutType.FULL}>
      <PageTitle title={'アナリティクス'} />
      <Content>
        <AnalyticsResultCard
          title='A/Bテスト結果'
          data={abResults ?? {}}
          formatLabel={abGroupLabel}
          emptyText='A/Bテストデータがまだありません'
          emptyHint='レコメンドAPIで ab_group パラメータを使用してください'
        />
        <AnalyticsResultCard
          title='アルゴリズム性能比較'
          data={algorithmPerformance ?? {}}
          formatLabel={(key) => algorithmName(key as Parameters<typeof algorithmName>[0])}
          emptyText='アルゴリズム性能データがまだありません'
          emptyHint='レコメンドが配信されるとデータが蓄積されます'
        />
      </Content>
    </Main>
  )
}

export default AnalyticsPage
